import axios from 'axios'
import store from '@/store'
import { getCookie, getDomain } from '@/utils/cookie'
import {
  handleApiSessionGuard,
  handleNetworkSessionGuard
} from '@/utils/auth'

const token = getCookie(getDomain() + '-Token')
if (token) {
  axios.defaults.headers.Authorization = 'Bearer ' + token
}

function skipGlobalLoading (config) {
  // 기본: 전체 화면 로딩 없음. 각 화면/컴포넌트에서 인라인 로딩 처리.
  if (config && config.globalLoading === true) return false
  return true
}

axios.interceptors.request.use(config => {
  const stored = getCookie(getDomain() + '-Token')
  if (stored) {
    config.headers.Authorization = 'Bearer ' + stored
  }
  if (!skipGlobalLoading(config)) {
    store.commit('loading/START_API')
  }
  return config
})

axios.interceptors.response.use(
  response => {
    if (!skipGlobalLoading(response.config)) {
      store.commit('loading/END_API')
    }

    const body = response && response.data
    handleApiSessionGuard(body, response.config, { toast: true })

    return response
  },
  error => {
    if (error.config && !skipGlobalLoading(error.config)) {
      store.commit('loading/END_API')
    }

    const body = error.response && error.response.data
    if (handleApiSessionGuard(body, error.config, { toast: true })) {
      return Promise.reject(error)
    }

    handleNetworkSessionGuard(error, error.config, { toast: true })

    if (error.response && error.response.status === 401) {
      delete error.config.headers.Authorization
    }

    return Promise.reject(error)
  }
)

export default axios
